// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export function widgetLocationToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.businessName !== undefined)
        o['businessName'] = m.businessName;
    if (m.address !== undefined)
        o['address'] = m.address;
    if (m.address2 !== undefined)
        o['address2'] = m.address2;
    if (m.city !== undefined)
        o['city'] = m.city;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.zip !== undefined)
        o['zip'] = m.zip;
    if (m.country !== undefined)
        o['country'] = m.country;
    return o;
}
export function widgetLocationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        businessName: (_b = o['businessName']) !== null && _b !== void 0 ? _b : '',
        address: (_c = o['address']) !== null && _c !== void 0 ? _c : '',
        address2: (_d = o['address2']) !== null && _d !== void 0 ? _d : '',
        city: (_e = o['city']) !== null && _e !== void 0 ? _e : '',
        state: (_f = o['state']) !== null && _f !== void 0 ? _f : '',
        zip: (_g = o['zip']) !== null && _g !== void 0 ? _g : '',
        country: (_h = o['country']) !== null && _h !== void 0 ? _h : '',
    };
}
export function listWidgetLocationsRequestToJson(m) {
    const o = {};
    if (m.widgetId !== undefined)
        o['widgetId'] = m.widgetId;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.query !== undefined)
        o['query'] = m.query;
    return o;
}
export function listWidgetLocationsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        widgetId: (_a = o['widgetId']) !== null && _a !== void 0 ? _a : '',
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
        query: (_d = o['query']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listWidgetLocationsResponseToJson(m) {
    const o = {};
    if (m.locations !== undefined) {
        o['locations'] = m.locations.map(e => widgetLocationToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listWidgetLocationsResponseFromJson(o) {
    var _a, _b, _c;
    return {
        locations: ((_a = o['locations']) !== null && _a !== void 0 ? _a : []).map(e => widgetLocationFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
